import { render, staticRenderFns } from "./billOverseasSCenterView.vue?vue&type=template&id=35c54856&"
import script from "./billOverseasSCenterView.vue?vue&type=script&lang=js&"
export * from "./billOverseasSCenterView.vue?vue&type=script&lang=js&"
import style0 from "./billOverseasSCenterView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c54856')) {
      api.createRecord('35c54856', component.options)
    } else {
      api.reload('35c54856', component.options)
    }
    module.hot.accept("./billOverseasSCenterView.vue?vue&type=template&id=35c54856&", function () {
      api.rerender('35c54856', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/billOverseasSCenterView.vue"
export default component.exports